import { createClasses } from "@bloomberg/media-ui-core";
import React from "react";
import { PropsWithClassAndChildren } from "../types";

import styles from "./GridFull.module.css";

export function GridFull({
  children,
  className,
  ...args
}: PropsWithClassAndChildren) {
  const cx = createClasses([styles.gridFull, className]);

  return (
    <div className={cx} {...args}>
      {children}
    </div>
  );
}
